import { Box, Flex, Spinner, Text, VStack } from '@chakra-ui/react';
import type { GoogleDrivePermission } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';
import DriveMemberRow, { type DriveMemberBadge } from './DriveMemberRow';

const I18N_PREFIX = 'integrations.googleDrive.sharing';

interface DriveCurrentAccessSectionProps {
  permissions: GoogleDrivePermission[];
  badgeFor: (permission: GoogleDrivePermission) => DriveMemberBadge;
  revokingId: string | null;
  onRevoke: (permission: GoogleDrivePermission) => void;
  isLoading: boolean;
  isError: boolean;
}

const DriveCurrentAccessSection = ({
  permissions,
  badgeFor,
  revokingId,
  onRevoke,
  isLoading,
  isError,
}: DriveCurrentAccessSectionProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Text fontSize="sm" fontWeight="medium" mb={2}>
        {t(`${I18N_PREFIX}.currentAccessLabel`)}
      </Text>
      {isLoading ? (
        <Flex py={4} justify="center">
          <Spinner size="sm" />
        </Flex>
      ) : isError ? (
        <Text fontSize="sm" color="red.fg">
          {t(`${I18N_PREFIX}.errors.loadFailed`)}
        </Text>
      ) : (
        <VStack
          align="stretch"
          gap={0}
          borderWidth="1px"
          borderColor="gray.100"
          rounded="lg"
          maxH="200px"
          overflowY="auto"
        >
          {permissions.map((permission) => (
            <DriveMemberRow
              key={permission.id}
              permission={permission}
              badge={badgeFor(permission)}
              isRevoking={revokingId === permission.id}
              onRevoke={() => onRevoke(permission)}
            />
          ))}
        </VStack>
      )}
    </Box>
  );
};

export default DriveCurrentAccessSection;
